import request from '@/router/axios.js';
import crypto from "@/util/crypto.js";

const decryptTransform = (data) => {
  //解密
  try {
    // 解密
    const backdata = crypto.decrypt(data);
    return backdata;
  } catch (error) {
    // 处理解密过程中的异常
    const backdata = data;
    return backdata;
  }
};

const encryption = (data) => {
    let text = JSON.stringify(data);
    let key  = crypto.encrypt(text);
    let formData = new FormData();
    formData.append('data', key);
    return formData
  }

//患者来源下拉选择
// http://swaggerdev.ygjkq.com:18000/doc.html#/%E8%BF%9E%E9%94%81%E7%BB%84%E7%BB%87/%E4%BC%81%E5%BE%AEtab%E9%A1%B5%E5%B5%8C%E5%85%A5%E9%A1%B5%E9%9D%A2%E6%8E%A5%E5%8F%A3/selectListUsingPOST
export const sourceList = (data) => {
    let formData = encryption(data);
    return request({
      url: '/api/ygj-chain/v1.0/wecom/select-source-list',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
    })
}
  
  
  //企微患者快速建档
  export const quickCreateQWPatientRecord = (data) => {
    let formData = encryption(data);
    return request({
      url: '/api/ygj-patient/v1.0/wecom/patient/submit-wecom',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
    })
  }
  

  //根据联系人id获取当前用户添加的企微线索

  export const getUserLeads = (data) => {
    let formData = encryption(data);
    return request({
      url: '/api/ygj-integration/v1.0/external-contact/wecom/get-my-contact',
      method: 'post',
      data: formData,
      transformResponse: [decryptTransform],
    })
  }

